import script from "./AddressChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressChip.vue?vue&type=script&lang=ts&setup=true"

import "./AddressChip.vue?vue&type=style&index=0&id=1fa6a882&lang=scss"

const __exports__ = script;

export default __exports__